import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';
import { startCase } from 'lodash';
import cookie from 'vue-cookie'
var querystring = require('querystring');
const tokenAuthCrm = cookie.get('crm_auth_token');

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        salesCardContent: null,
        flatsWords_arr: null,
        // server state vars
        // gCap_siteKey: '6Ldn2MopAAAAAIQxQ498E5IvfF_8sSLgluVfSEZb',
        // gCap_siteKey: '6LfSTm4qAAAAAIIHIl2bnij6xlRkmsb-wY8h8bZR',
        gCap_siteKey: '6LeoHdYqAAAAANywPphDqugWGUVng0WBpaJu-tmp',
        // // 6LfSTm4qAAAAANCmb62GoUHV7jn0O06KH5Z6wM2Z
        pageSetup: null,
        sales_flatspage_data: null,
        forms: null,
        //Contacts page
        contactsPage: null,
        contactsCardAnimate: true,
        contactsMapCoords: [],
        pinCoords: {
            lat: null,
            lng: null,
        },
        // end contacts page
        saleFilterParams: null,
        
        //
        formConsultData: null,
        isOpenSendwich: false,
        isOpenFormConsult: false,

        flats: null,
        flatCards: [],
        flatCardsDefault: [],
        flatsCardsGlobal: [],
        flatsCardsGlobalDefault: [],
        housesCardsGlobal: [],
        housesCardsGlobalDefault: [],
        activeFlatsClass: 'villa',
        activeFlatsClassKohOta: 'flats',

        flatsItems: null,
        flatCard: null,
        flatsFilterData: null,
        pagin_PageNumber: 1,
        gridView: true,
        flatsEmptyMsg: false,
        objectDataCrm: null,
        visibleFilterMobile: false,
        FilterResetTrigger: false,
        modalData: null,
        hidePaginBtn: false,
        flatsPagination: {
            allApartments: 0,
            remainingApartments: 0,
            remainingPages: 0,
        },

        // global data var
        LDM_complex: null,
        currentCity: null,
        currentPhone: null,
        isOpenSendwichMobile: false,
        isOpenFormLandModal: false,
        animatedEnd: false,
        //  var for flat section
        cardAll: [],
        defaultCountCards: [],
        animateCards: true,

        coockieBanerTopVisible: false,
        // var for news section
        newsData: [],

        isMobileChecker: false,
        offsetResponse: -100,
        ucoCRM_oauth_token: null,
    },
    getters: {
        loadSalesCardContent: state => state.salesCardContent,
        loadFlatsWords: state => state.flatsWords_arr,


        loadGcap_sitekey: state => state.gCap_siteKey,
        loadPageSetUp: state => state.pageSetup,
        loadSalesFlatsPageData: state => state.sales_flatspage_data,
        loadForms: state => state.forms,
        loadIsMobileChecker: state => state.isMobileChecker,
        loadOffsetResponse: state => state.offsetResponse,

        // loadSalesCardPage: state => state.salesCardPage,
        loadSaleCardItem: state => state.saleCardItem,
        loadSalesFilterCardParams: state => state.saleFilterParams,

        //CONTACTS PAGE
        loadContactsPage: state => state.contactsPage,
        loadContactsCardAnimate: state => state.contactsCardAnimate,
        loadContactsMapCoords: state => state.contactsMapCoords,
        loadPinCoords: state => state.pinCoords,
        //end contacts getters

        loadFormConsultData: state => state.formConsultData,
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,

        loadFlatsPage: state => state.flats,
        loadFlatsData: state => state.flatCards,
        loadActiveFlatsClass: state => state.activeFlatsClass,
        loadActiveFlatsClassKohOta: state => state.activeFlatsClassKohOta,

        loadFlatsItems: state => state.flatsItems,
        loadFlatCard: state => state.flatCard,
        loadFlatsFilterData: state => state.flatsFilterData,
        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg,
        loadObjectDataCrm: state => state.objectDataCrm,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadLandFlatsGridView: state => state.gridView,
        loadSalesLandModalDataArr: state => state.modalData,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadFlatsPagination: state => state.flatsPagination, // параметры остаточных значений(счетчиков) пагинации


        // loadFlatsCardsDefault: state => state.flatCardsDefault,
        loadLDM_complex: state => state.LDM_complex,
        loadFlatsCardsGlobal: state => state.flatsCardsGlobal,
        loadFlatsCardsGlobalDefault: state => state.flatsCardsGlobalDefault,

        loadSalesLandCardAnimate: state => state.animateCards,
        loadNewsData: state => state.newsData,
        // custom
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadisOpenFormModal: state => state.isOpenFormModal,
        loadIsOpenSendwich: state => state.isOpenSendwich,
        loadIsOpenSendwichMobile: state => state.isOpenSendwichMobile,
        loadCockieBanerTopVisible: state => state.coockieBanerTopVisible,
        loadCurCity: state => state.currentCity,
        loadCurPhone: state => state.currentPhone,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
    },
    actions: {
        // SALES CARD PROMO/LAND
        getSalesCardContent({commit}, payload) {
            if (payload != 'test-theme' && payload != 'setup-theme') {
                axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects/?filter[project_name]=' + payload).then(async (response) => {
                    // console.log(window.url + window.GlobalLang + '/wp-json/wp/v2/projects/?filter[project_name]=' + payload);
                    // console.log(response.data, payload, 'content Shablon Project Card Land App')
                    commit('salesCardContent', response.data[0].acf);
                });
            }
        },
        getFlatsWordsData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings/898').then(async (response) => {
                // console.log(response.data.acf, 'flats data fraze');
                commit('flatsWords', response.data.acf);
            });
        },
        // END SALES CARD PROMO/LAND
        // FLATS FROM CRM
        // AUTH 2.0 REST API REQUESTS
        getFlatsItems({commit, dispatch, state}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                        headers: { 
                            'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                        } 
                    }).then((response) => {
                        // console.log(response, response.data.data, 'apartments after AUTH');
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response.data, error.response.status);
                        // if (error.response.data.error == 'invalid_token') {
                        //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                        // }
                    });
                });
            }
        },
        getFlatsByFilter({commit, dispatch, state}, payload) { // FLATS LOAD BY FILTER
            // console.log(payload, 'GET FLATS BY FILTER')
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'FILTER APPS after AUTH');
                commit('flatsItemsArr', response.data.data);
            }).catch((error) => {
                console.log('error getApartments filter', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        getFlatsByPagination({commit, dispatch, state}, payload) { // FLATS LOAD BY pagination with filter and pagePaginNumber params
            // console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'pagination after AUTH');
                commit('flatsItemsArrPagination', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        getFlatsPagintationCounters({commit, dispatch, state}, payload) {
            axios.post(window.CRMurl + '/rest/prices/getApartmentsCount', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'paginationCounter after AUTH');
                commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination Counter', error.response.data, error.response.status);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },
        // OBJECT HOUSE FROM CRM 
        getObjectFromCRM({commit, dispatch, state}, payload) {
            var dataArr;
            if (window.host != 'landmark') {
                dataArr = payload;
            } else {
                dataArr = {'complexCodes': ['LDM', 'LDM-II', 'LDM-III', 'LDM-IV']};
            }
            // console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getComplexes', dataArr, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                if (window.host != 'landmark') {
                    commit('setObjectDataCRM', response.data.data);
                } else {
                    commit('setLDM_complex', response.data.data);
                    // console.log(response.data.data, 'ARR object')
                }
                // console.log(response, response.data.data, 'getComplexes after AUTH');
            }).catch((error) => {
                console.log('error getComplexes', error.response.data, error.response.status);
                commit('setObjectDataCRM', []);
                // if (error.response.data.error == 'invalid_token') {
                //     dispatch('getCrmAuthChecker', {'error' : 'invalid_token'});
                // }
            });
        },  
        getCrmAuthToken({commit}, payload) { // Получение Токена из СРМ системы для oauth 2.0 в необходимых для авторизации запросов
            return new Promise((resolve, reject) => {
                axios.post('https://admin.shablon.bazis.kz/server/new-auth.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
                    if (response) {
                        var tokenParse = JSON.parse(response.data.token);
                        var token = tokenParse.access_token;
                        // console.log(token,'- token');
                        commit('setOauthToken_from_server', token);
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                    // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                }).catch((error) => {
                    console.log('error ' + error, 'erorr Get Token');
                    resolve(false);
                });
            });
        },
        sendFormDataToCRM({commit, state}, payload) {
            // console.log(payload, 'STORE DATA FORM')
            return new Promise((resolve, reject) => {
                axios.post('https://bazis-online.kz/crmc/rest/leads/lead', payload, {
                    headers: { 
                        'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                        "Content-Type": "application/json",
                    } 
                }).then((response) => {
                    // console.log('form send in crm complete')
                    // console.log(response);
                    resolve(response)
                }).catch((error) => {
                    console.log('error SEND FORM', error.response.data, error.response.status);
                    resolve(error)
                });
            });
        },
        // action for flat section
        clearFlatCardAll({commit}, payload) {
            commit('cardAllClear', payload);
        },
        clearNewsData({commit}) {
            commit('newsDataClear');
        }
    },
    mutations: {
        // server mutations
        salesCardContent(state, data) {
            state.salesCardContent = data;
        },
        flatsWords(state, data) {
            state.flatsWords_arr = data
        },
        

//////////////




        FilterSaleItemCard_Set(state, data) {
            state.saleFilterParams = data
        },
        // Main server mutations
        setOauthToken_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        Sales_flatsPage(state, data) {
            state.sales_flatspage_data = data
        },
        formsData(state, data) {
            state.forms = data
        },
        setMobileCheckerState(state, data) {
            state.isMobileChecker = data
        },
        setOffsetResponse(state, data) {
            state.offsetResponse = data
        },
        //contacts page
        contactsPage(state, data) {
            state.contactsPage = data
        },
        setContactsCardAnimation(state, data) {
            state.contactsCardAnimate = data
        },
        filterContactsMapCoords(state, data) {
            state.contactsMapCoords = data
        },
        setContactsPinCoords(state, data) {
            // console.log(data)
            state.pinCoords.lat = data.lat,
            state.pinCoords.lng = data.lng
        },
        // end contacts page
        setCurCity(state, data) {
            state.currentCity = data;
        },
        coockieBanerTopVisible(state, data) {
            state.coockieBanerTopVisible = data;
        },
        getFormConsultData(state, data) {
            state.formConsultData = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        Flats(state, flats) {
            state.flats = flats
        },
        FlatsCardsGlobalArr(state, data) {
            var flatsArr = [];
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobalDefault = [];
            for (var i = 0; i < data.length; i++) {
                flatsArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                    slug: data[i].slug,
                }));
            }
            state.flatsCardsGlobal = flatsArr;
            state.flatsCardsGlobalDefault = flatsArr;
        },
        flatsPaginationCountersSet(state, data) {
            state.flatsPagination.allApartments = data.allApartments;
            state.flatsPagination.remainingApartments = data.remainingApartments;
            state.flatsPagination.remainingPages = data.remainingPages;
        },
        changeActiveFlatsClass(state, data) {
            state.activeFlatsClass = data
            state.activeFlatsClassKohOta = data
        },
        // global mutations for vars
        Open_Form_Modal(state, data) {
            state.isOpenFormModal = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_sendwich_mobile(state, data) {
            state.isOpenSendwichMobile = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
        Animation_End(state, data) {
            state.animatedEnd = data
        },
        // mutations for flat section
        cardAll(state, allcards) {
            state.cardAll.push(allcards);
        },
        cardAllClear(state, data) {
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobal = data;
            // console.log(data, 'FLATS filter data')
        },
        setCardAllToDefault(state, setDefault) {
            state.cardAll = [];
            state.cardAll = setDefault;
        },
        defaultCountCards(state, defaultCards) {
            state.defaultCountCards = defaultCards;
        },
        
       
        animateCards(state, data) {
            state.animateCards = data;
        },
        // mutations for news section
        newsData(state, data) {
            state.newsData.push(data);
        },
        newsDataClear(state, data) {
            state.newsData = []
        },
        setFlatsAqualina(state, data) {
            state.flatsCardsGlobal = data;
            state.flatsCardsGlobalDefault = data;
        },
        setFlatsKohota(state, data) {
            state.flatsCardsGlobal = data.flats;
            state.flatsCardsGlobalDefault = data.flats;

            state.housesCardsGlobal = data;
            state.housesCardsGlobalDefault = data;
        },
        updateFlatsKohOta(state, data) {
            if (data == 'flats') {
                state.flatsCardsGlobal = state.housesCardsGlobal.flats;
                state.flatsCardsGlobalDefault = state.housesCardsGlobal.flats;
            } else {
                state.flatsCardsGlobal = state.housesCardsGlobal.houses;
                state.flatsCardsGlobalDefault = state.housesCardsGlobal.houses;
            }
        },

        // flats from CRM
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
            } else {
                state.flatsEmptyMsg = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, data.length, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            if (data.length == 0) {
                state.hidePaginBtn = true
            }
            // console.log(state.flatsItems);
        },
        setObjectDataCRM(state, data) {
            state.objectDataCrm = data[0];
        },
        setLDM_complex(state, arr_data) {
            // console.log(arr_data, 'TEST DATA')
            var arrData = arr_data;
            var priceArr = [];
            if (arrData.length > 0) {
                for (var i=0; i < arrData.length; i++) {
                    priceArr.push(arrData[i].minMeterPrice)
                }
                const validNumbers = priceArr.filter(value => value !== null).map(Number);
                const minNumber = validNumbers.length > 0 ? Math.min(...validNumbers) : null;
                state.LDM_complex = minNumber;
            } else  {
                // console.log('false', 'ERROR IN LDM COMPLEX');
            }
        },
        setFlatsFilterData(state, data) {
            state.flatsFilterData = data
        },
        UpdatePaginPageNumber(state, data) {
            state.pagin_PageNumber = data
        },
        // for flats
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        gridView(state, data) {
            state.gridView = data;
        },
        modalData(state, data) {
            state.modalData = data
        },
    }
})
